export const normalize = (path: string | undefined): string => {
    if (!path) return '';
    const trimmed = path.endsWith('/') ? path.slice(0, -1) : path;
    return trimmed || '/';
};

export const isActive = (current: string, target: string | undefined): boolean =>
    normalize(current) === normalize(target);
